import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Header } from "../components/landing/Header";
import { Hero } from "../components/landing/Hero";
import { StatsBar } from "../components/landing/StatsBar";
import { Problem } from "../components/landing/Problem";
import { HowItWorks } from "../components/landing/HowItWorks";
import { Signals } from "../components/landing/Signals";
import { Comparison } from "../components/landing/Comparison";
import { UserContract } from "../components/landing/UserContract";
import { FinalCTA } from "../components/landing/FinalCTA";
import { Footer } from "../components/landing/Footer";
import AuthModal from "../components/AuthModal";
import ExtensionBanner from "../components/ExtensionBanner";
import { captureSignupSource } from "../lib/signupSource";
import ResumeUploadModal from "../components/ResumeUploadModal";

export default function Landing() {
  const navigate = useNavigate();
  // null = closed, otherwise the mode AuthModal opens in ("login" | "register")
  const [authMode, setAuthMode] = useState(null);
  const [showResumeUpload, setShowResumeUpload] = useState(false);
  useEffect(() => {
    captureSignupSource();
  }, []);

  const handleAuthed = (user) => {
    setAuthMode(null);
    // `onboarded` alongside active_profile_id (not active_profile_id
    // alone) — the same pair ProtectedRoute.jsx already treats as "done",
    // e.g. the admin OTP bypass sets onboarded=true with no resume/profile
    // at all and still belongs on the dashboard, not the upload modal.
    if (user?.active_profile_id || user?.onboarded) {
      navigate("/dashboard");
    } else {
      setShowResumeUpload(true);
    }
  };

  return (
    <div className="min-h-screen bg-white text-ink" data-testid="landing-root">
      <ExtensionBanner />
      <Header onOpenAuth={setAuthMode} />
      <main>
        <Hero onOpenAuth={setAuthMode} />
        <StatsBar />
        <Problem />
        <HowItWorks />
        <Signals />
        <Comparison />
        <UserContract />
        <FinalCTA onOpenAuth={setAuthMode} />
      </main>
      <Footer />

      <AuthModal
        open={!!authMode}
        onClose={() => setAuthMode(null)}
        onAuthed={handleAuthed}
      />
      <ResumeUploadModal
        open={showResumeUpload}
        onSkip={() => {
          setShowResumeUpload(false);
          navigate("/dashboard");
        }}
        onDone={() => {
          setShowResumeUpload(false);
          navigate("/dashboard");
        }}
      />
    </div>
  );
}
